import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const createBusinessProfile = async (businessData) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.BUSINESSES.BUSINESS_CREATE, businessData);
        return response.data;
    } catch (error) {
        console.error('Failed to create business profile:', error);
        throw error;
    }
};

export const getBusinessProfile = async (id) => {
    try {
        const response = await apiClient.get(`${API_ENDPOINTS.BUSINESSES.BUSINESS_PROFILE}${id}/`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch business profile:', error);
        throw error;
    }
};

// For the currently logged-in user's business profile
export const getOwnBusinessProfile = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.BUSINESSES.OWN_BUSINESS_PROFILE);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch own business profile:', error);
        throw error;
    }
};

export const getBusinessProfileId = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.BUSINESSES.BUSINESS_ID);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch business profile ID:', error);
        throw error;
    }
};

export const getBusinessExpenseSummary = async (businessId, year = null) => {
    try {
        const query = year ? `?year=${year}` : '';
        const response = await apiClient.get(`${API_ENDPOINTS.BUSINESSES.EXPENSE_SUMMARY}${businessId}/${query}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch business expense summary:', error);
        throw error;
    }
};

export const getBusinessSummary = async (businessId, year) => {
    try {
        const params = {};
        if (year) params.year = year;

        const response = await apiClient.get(
            `${API_ENDPOINTS.BUSINESSES.SUMMARY}${businessId}/`,
            { params }
        );
        return response.data; // { revenue: ..., total_customers: ..., total_projects: ... }
    } catch (error) {
        console.error('Failed to fetch business summary:', error);
        throw error;
    }
};

// Profile image upload
export const businessImageUpload = async (formData) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.BUSINESSES.UPLOAD_PROFILE_IMAGE, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response;
    } catch (error) {
        console.error("Error uploading freelancer image", error);
        throw error; // Re-throw the error for the caller to handle
    }
};

// Upload a new business image
export const uploadBusinessImage = async (formData) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.BUSINESSES.UPLOAD_IMAGE, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to upload business image:', error);
        throw error;
    }
};

// Delete a business image
export const deleteBusinessImage = async (imageId) => {
    try {
        const response = await apiClient.delete(API_ENDPOINTS.BUSINESSES.DELETE_IMAGE(imageId));
        return response.data;
    } catch (error) {
        console.error('Failed to delete business image:', error);
        throw error;
    }
};

// Fetch all images for a business
export const getBusinessImages = async (businessId) => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.BUSINESSES.BUSINESS_IMAGES(businessId));
        return response.data; // Expecting an array of images
    } catch (error) {
        console.error('Failed to fetch business images:', error);
        throw error;
    }
};

export const updateBusinessProfile = async (updateData) => {
    try {
        const response = await apiClient.patch(API_ENDPOINTS.BUSINESSES.BUSINESS_UPDATE, updateData);
        return response.data;
    } catch (error) {
        console.error('Error updating business profile:', error);
        throw error;
    }
};